import { Validators } from '@angular/forms';


export const LoginUserField = {
  email: [ localStorage.getItem('email') || '', [Validators.required, Validators.email]],
  password: ['', Validators.required],
  remember: [false]
}
